import { PieceType, TeamType, Piece, Position } from "../Constants";
import {
  GetPossiblePawnMoves,
  bishopMove,
  kingMove,
  knightMove,
  pawnMove,
  queenMove,
  rookMove,
} from "./rules";

export default class Referee {
  isEnPassantMove(
    initialPosition: Position,
    desiredPosition: Position,
    type: PieceType,
    team: TeamType,
    boardState: Piece[]
  ) {
    const pawnDirection = team === TeamType.OUR ? 1 : -1;
    if (type === PieceType.PAWN) {
      if (
        (desiredPosition.x - initialPosition.x === -1 ||
          desiredPosition.x - initialPosition.x === 1) &&
        desiredPosition.y - initialPosition.y === pawnDirection
      ) {
        const piece = boardState.find(
          (p) =>
            p.position.x === desiredPosition.x &&
            p.position.y === desiredPosition.y - pawnDirection &&
            p.enPassant
        );
        if (piece) {
          return true;
        }
      }
    }

    return false;
  }

  isValidMove(
    initialPosition: Position,
    desiredPosition: Position,
    type: PieceType,
    team: TeamType,
    boardState: Piece[]
  ) {
    switch (type) {
      case PieceType.PAWN:
        return pawnMove(initialPosition, desiredPosition, team, boardState);
      case PieceType.KNIGHT:
        return knightMove(initialPosition, desiredPosition, team, boardState);
      case PieceType.BISHOP:
        return bishopMove(initialPosition, desiredPosition, team, boardState);
      case PieceType.ROOK:
        return rookMove(initialPosition, desiredPosition, team, boardState);
      case PieceType.QUEEN:
        return queenMove(initialPosition, desiredPosition, team, boardState);
      case PieceType.KING:
        return kingMove(initialPosition, desiredPosition, team, boardState);
      default:
        return false;
    }
  }

  getValidMoves(piece: Piece, boardState: Piece[]): Position[] {
    switch (piece.type) {
      case PieceType.PAWN:
        return GetPossiblePawnMoves(piece, boardState);
      default:
        return [];
    }
  }
}
